/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_choose_an_option = /** @type {(inputs: {}) => string} */ () => {
	return `Vyberte možnost`
};

const da_choose_an_option = /** @type {(inputs: {}) => string} */ () => {
	return `Vælg en mulighed`
};

const de_choose_an_option = /** @type {(inputs: {}) => string} */ () => {
	return `Bitte wählen Sie eine Option`
};

const en_choose_an_option = /** @type {(inputs: {}) => string} */ () => {
	return `Choose an option`
};

const es_choose_an_option = /** @type {(inputs: {}) => string} */ () => {
	return `Elige una opción`
};

const fr_choose_an_option = /** @type {(inputs: {}) => string} */ () => {
	return `Choisissez une option`
};

const hu_choose_an_option = /** @type {(inputs: {}) => string} */ () => {
	return `Válassz egy lehetőséget`
};

const it_choose_an_option = /** @type {(inputs: {}) => string} */ () => {
	return `Scegli un'opzione`
};

const nl_choose_an_option = /** @type {(inputs: {}) => string} */ () => {
	return `Kies een optie`
};

const pl_choose_an_option = /** @type {(inputs: {}) => string} */ () => {
	return `Wybierz opcję`
};

const pt_choose_an_option = /** @type {(inputs: {}) => string} */ () => {
	return `Escolha uma opção`
};

const sv_choose_an_option = /** @type {(inputs: {}) => string} */ () => {
	return `Välj ett alternativ`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const choose_an_option = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.choose_an_option(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("choose_an_option", locale)
	if (locale === "cs") return cs_choose_an_option(inputs)
	if (locale === "da") return da_choose_an_option(inputs)
	if (locale === "de") return de_choose_an_option(inputs)
	if (locale === "en") return en_choose_an_option(inputs)
	if (locale === "es") return es_choose_an_option(inputs)
	if (locale === "fr") return fr_choose_an_option(inputs)
	if (locale === "hu") return hu_choose_an_option(inputs)
	if (locale === "it") return it_choose_an_option(inputs)
	if (locale === "nl") return nl_choose_an_option(inputs)
	if (locale === "pl") return pl_choose_an_option(inputs)
	if (locale === "pt") return pt_choose_an_option(inputs)
	return sv_choose_an_option(inputs)
};